import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useGetSegmentoCnae() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getSegmentoCnae = useCallback(
        (cnae: string) => invocarApi({
            url: `v1/segmentos/${cnae}`,
            method: 'GET',
            enviarTokenUsuario: false,
            baseURL: 'https://api.touchone.com.br/api/'
        }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        getSegmentoCnae,
    };
}
